import { forwardRef } from "react";
import { Icon, IconClientSVGProps } from "@repo/ui/icon";

export const Pause = forwardRef<SVGSVGElement, IconClientSVGProps>(
  ({ label, ...props }, ref) => {
    return (
      <Icon label={label}>
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="20"
          height="20"
          viewBox="0 0 20 20"
          fill="none"
          ref={ref}
          {...props}
        >
          <rect x="4" y="4" width="4" height="12" fill="currentcolor" />
          <rect x="12" y="4" width="4" height="12" fill="currentcolor" />
        </svg>
      </Icon>
    );
  },
);

Pause.displayName = "Pause";
